import type { DraggableSyntheticListeners, UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties, PropsWithChildren } from 'react';
import React, { createContext, useContext, useMemo } from 'react';

interface Props {
	id: UniqueIdentifier;
	className?: string;
}

interface Context {
	attributes: Record<string, any>;
	listeners: DraggableSyntheticListeners;
	ref(node: HTMLElement | null): void;
}

const SortableItemContext = createContext<Context>({
	attributes: {},
	listeners: undefined,
	ref() {},
});

export function SortableItem({ children, id, className }: PropsWithChildren<Props>) {
	const { attributes, isDragging, listeners, setNodeRef, setActivatorNodeRef, transform, transition } = useSortable({ id });
	const context = useMemo(
		() => ({
			attributes,
			listeners,
			ref: setActivatorNodeRef,
		}),
		[attributes, listeners, setActivatorNodeRef]
	);

	const style: CSSProperties = {
		opacity: isDragging ? 0.4 : undefined,
		transform: CSS.Translate.toString(transform),
		transition,
	};

	return (
		<SortableItemContext.Provider value={context}>
			<div className={className} ref={setNodeRef} style={style}>
				{children}
			</div>
			{/* <li className={styles.SortableItem} ref={setNodeRef} style={style}>
				{children}
			</li> */}
		</SortableItemContext.Provider>
	);
}

type HeaderProps = {
	className?: string;
};
export function DragHandle({ children, className }: PropsWithChildren<HeaderProps>) {
	const { attributes, listeners, ref } = useContext(SortableItemContext);

	return (
		<span className={className} {...attributes} {...listeners} ref={ref}>
			{children}
		</span>
	);
}
